if (Array.from === undefined) {
	Array.from = (x: any) => Array.prototype.slice.call(x);
}
